import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { DisbursementListItemDto } from '../../../../../config/registrationConfig'
import { Stack } from '@fluentui/react'
import { Badge, Text } from '@fluentui/react-components'
import useVatType from '../../../../../hooks/useVatType'
import FormattedDateBadge from '../../../../Date/FormattedDateBadge'
import useUsers from '../../../../../hooks/useUsers'

export default function DisbursementLineItem({ lineItem, entity, findQuantity }: LineItemProps<DisbursementListItemDto>): ReactElement {
    const { getUserById } = useUsers()
    const { vatTypeName } = useVatType(entity.vatType)

    const disbursementItem: DisbursementListItemDto =
        findQuantity(lineItem?.entityId ?? entity?.id)?.map(quantity => ({
            ...entity,
            id: lineItem?.entityId ?? entity?.id,
            duration: quantity.amount,
            rate: { amount: quantity.rate, currency: entity?.rate.currency || 'EUR' },
            description: quantity.description,
            date: quantity.date,
            user: getUserById(quantity.user),
        }))?.[0] || entity

    return (
        <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
            <Text strikethrough={!entity}>{disbursementItem.description}</Text>
            <Stack horizontal tokens={{ childrenGap: 's2' }}>
                <FormattedDateBadge date={disbursementItem.date} />
                <Badge size="medium" appearance="tint">
                    {vatTypeName}
                </Badge>
            </Stack>
        </Stack>
    )
}
